import React, { useState } from 'react'
import ReactGA from 'react-ga'
import HeaderActionsComponent from '../components/HeaderActionsComponent'
import DialogSearch from './DialogSearch'
import DialogShare from './DialogShare'

const Header = ({
  searchParams,
  setSearchParams,
  setPhotosState,
  pagination,
  setPagination,
  pageProps,
}) => {
  const [dialogSearch, setDialogSearch] = useState({
    isOpen: false,
    data: null,
  })
  const [dialogShare, setDialogShare] = useState({ isOpen: false, data: null })

  const [searchState, setSearchState] = useState({
    telespectador: '',
    data_inicio: null,
    data_fim: null,
  })

  const search = searchState => {
    setPagination({ ...pagination, currentPage: 0 })
    setSearchParams(searchState)
    setDialogSearch({ isOpen: false, data: null })

    ReactGA.event({
      category: pageProps.title,
      action: 'Search button clicked',
    })
  }

  const clearSearch = () => {
    setPagination({ ...pagination, currentPage: 0 })
    search({})
    setPhotosState([])
    setSearchState({})
  }

  return (
    <>
      <HeaderActionsComponent
        setDialogSearch={setDialogSearch}
        setDialogShare={setDialogShare}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        clearSearch={clearSearch}
      />

      <DialogSearch
        dialog={dialogSearch}
        setDialog={setDialogSearch}
        search={search}
        clearSearch={clearSearch}
        searchState={searchState}
        setSearchState={setSearchState}
      />

      <DialogShare dialog={dialogShare} setDialog={setDialogShare} />
    </>
  )
}

export default Header
